import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'toShortDate'
})
export class ToShortDatePipe implements PipeTransform {

    transform(value: any, args?: any): any {
        if (args === 'input_format' && value && value.indexOf('-') > 1) {
            let fullDate, rest;
            [fullDate, rest] = value.toLowerCase().split('t');

            return fullDate;
        } else if (value && value.indexOf('-') > 1) {
            let fullDate, rest;
            [fullDate, rest] = value.toLowerCase().split('t');

            let year, month, day;
            [year, month, day] = fullDate.split('-');

            return `${day}/${month}/${year}`;
        } else {
            return '-';
        }
    }

}



// WEBPACK FOOTER //
// ./src/shared/pipes/toShortDate.pipe.ts